<template>
    <div class="form-group">
        <label class="label required">{{ $t("Loads") }}</label>
        <input
            type="text"
            class="form-control"
            v-model="displayValue"
            placeholder="Enter quantity"
            :disabled="is_view"
            @keypress="onlyNumbers"
        />
    </div>
</template>
  
<script>
export default {
    name: 'ProductLoads',
    props: {
        value: {
            type: [String, Number, Object],
            default: null
        },
        is_view : {
            type : Boolean,
            default : false
        }
    },
    computed: {
        displayValue: {
            get() {
                if (this.value === null || this.value === '') return '';
                // Formateamos para que muestre 1,000,000
                return new Intl.NumberFormat('en-US').format(this.value);
            },
            set(newValue) {
                // 1. Quitamos todo lo que no sea dígito (borra comas, puntos, espacios)
                const cleanValue = newValue.replace(/\D/g, '');
                
                // 2. Convertimos a número (o string vacío si no hay nada)
                const numericValue = cleanValue === '' ? null : parseInt(cleanValue, 10);
                
                // 3. Emitimos el valor "puro" al padre
                this.$emit('input', numericValue);
            }
        }
    },
    methods: {
        // Bloquea teclas que no sean números directamente en el teclado
        onlyNumbers(event) {
            const charCode = event.which ? event.which : event.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                event.preventDefault();
            }
        }
    }
}
</script>

<style scoped> 
    .label-custom {
        font-weight: 600;
        font-style: italic;
    }
    /* Estilo opcional para que se vea igual que un form-control estándar */
    .form-control:disabled {
        background-color: #e9ecef;
        cursor: not-allowed;
    }
</style>